module.exports = __webpack_public_path__ + "img/gxs.e73cbe89.svg";